import { render, staticRenderFns } from "./DataPanelFieldWrap.vue?vue&type=template&id=6dae4c71"
import script from "./DataPanelFieldWrap.vue?vue&type=script&lang=ts"
export * from "./DataPanelFieldWrap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports